export default __webpack_public_path__ + "static/media/delete.ecb5ce6d.png";